import { EventEmitter, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  invokeFirstComponentFunction = new EventEmitter();
  invokeLoginAttemptFunction  = new EventEmitter();
  invokeGetPackagesAssociated  = new EventEmitter();
  subsVar: Subscription;    
    
  constructor() { }
    
  onGoogleDirectionsSelected(obj) {    
    this.invokeFirstComponentFunction.emit(obj);    
  }

  onValidationAttempt(isValid) {    
    this.invokeLoginAttemptFunction.emit(isValid);    
  }

  onDependecyResolved(obj,cacheLabel){
    // TO DO
    /* debugger; */
    let sentObj = {
      cacheLabel: cacheLabel,
      obj: obj
    }

    if(cacheLabel == 'getCotizacion'){
      this.invokeGetPackagesAssociated.emit(obj);
    }
    this.invokeFirstComponentFunction.emit(sentObj);
  }

}